import { BroadcastChannel } from 'broadcast-channel';

type Message = {
  logout: boolean;
  audioWipeId?: string;
};

type SafeLogoutChannel = {
  onmessage: ((message: Message) => void) | null;
  postMessage: (message: Message) => Promise<void>;
  close: () => void;
};

const noopLogoutChannel: SafeLogoutChannel = {
  onmessage: null,
  postMessage: () => Promise.resolve(),
  close: () => undefined,
};

const createLogoutChannel = (): SafeLogoutChannel => {
  try {
    return new BroadcastChannel<Message>(
      'logout-channel'
    ) as unknown as SafeLogoutChannel;
  } catch {
    return noopLogoutChannel;
  }
};

export const logoutChannel: SafeLogoutChannel = createLogoutChannel();
